import { useAppSelector } from 'hooks/useAppSelector';
import { useNewSelectedCampaign } from './useNewSelectedCampaign';

export const useNewSelectedContract = () => {
  const { selectedContractId } = useAppSelector((state) => state.campaigns);
  const { selectedCampaign } = useNewSelectedCampaign();

  const selectedContract = selectedCampaign?.contractDetails?.find(
    (c) => c.contractId === selectedContractId
  );

  return selectedContract;
};
